import { FirstSectionProduct } from "./components/firstSection";


export const ProductPage = () => {
    return (
        <div>
            <FirstSectionProduct/>
        </div>
    );
};

